<div>
    <app-commercial-atacado-lista 
    [filtros]="filtros"
    (exibir)="selecionar($event)">
    </app-commercial-atacado-lista>
</div>